import React, { useRef, useState, type ReactNode } from "react";
import "swiper/css";
import "swiper/css/navigation"; // necesario para las flechas
import "swiper/css/pagination"; // necesario para los puntos
import "swiper/css/effect-fade";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper"; // tipado de Swiper
import {
  Navigation,
  Autoplay,
  Pagination,
  EffectCreative,
  EffectFade,
} from "swiper/modules";
import "./NavegationCarrusel.css";

type Props = {
  children: ReactNode; //recibe varios hijos
  sildesPerView?: number; //cuántos mostrar a al ver
  sildesPerViewTwo?: number;
  autoPlay?: boolean; //autoplay opcional
  navigation?: boolean; //ver los punto de navegación.
  pagination?: boolean; //puntos de pagina navegación.
  spaceBetween?: number;
  classNamex?: string;
  reference?: number;
  allowTouchMove?: boolean;
  loop?: boolean;
};

export const LayoutCarousel: React.FC<Props> = ({
  children,
  sildesPerView = 2,
  sildesPerViewTwo = 2,
  autoPlay = false,
  navigation = false,
  pagination = false,
  spaceBetween = 8,
  classNamex,
  reference = 0,
  allowTouchMove = true,
  loop = true,
}: Props) => {
  const swiperRef = useRef<SwiperClass | null>(null);
  swiperRef.current?.slideToLoop(reference, 0); // Mover al slide con índice 'reference' sin animación

  return (
    <div className="w-full">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        loop={loop}
        spaceBetween={spaceBetween}
        slidesPerView={sildesPerView}
        navigation={navigation}
        pagination={pagination ? { clickable: true, type: "bullets" } : false}
        autoplay={
          autoPlay ? { delay: 3000, disableOnInteraction: false } : false
        }
        speed={1000} //la animación tarde 1 segundo
        breakpoints={{
          0: { slidesPerView: sildesPerViewTwo == 2 ? 2 : sildesPerView }, // < 480px
          480: { slidesPerView: sildesPerViewTwo == 2 ? 3 : sildesPerView }, // 480px – 766px
          767: { slidesPerView: sildesPerViewTwo == 2 ? 4 : sildesPerView }, // 767px – 990px
          991: { slidesPerView: sildesPerViewTwo == 2 ? 5 : sildesPerView }, // 991px – 1199px
          1024: { slidesPerView: sildesPerViewTwo == 2 ? 5 : sildesPerView }, // >= 1200px
          1200: { slidesPerView: sildesPerView },
        }}
        className="rounded-2xl"
        allowTouchMove={allowTouchMove}
        onSwiper={(swiper) => (swiperRef.current = swiper)}>
        {React.Children.map(children, (child, index) => (
          <SwiperSlide
            key={index}
            className={classNamex != "" ? classNamex : "flex justify-center"}>
            {child}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export const LayoutCarouselV2: React.FC<Props> = ({
  children,
  sildesPerView = 2,
  sildesPerViewTwo = 2,
  autoPlay = false,
  navigation = false,
  pagination = false,
  spaceBetween = 8,
  classNamex,
}: Props) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const swiperRef = useRef<SwiperClass | null>(null);

  const handdleSlideChange = (swiper: SwiperClass) => {
    setActiveIndex(swiper.realIndex);
  };
  return (
    <div className="w-full">
      <Swiper
        modules={[Navigation, Autoplay, Pagination, EffectCreative, EffectFade]}
        onSlideChange={handdleSlideChange}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        effect="fade"
        loop={true}
        fadeEffect={{ crossFade: true }} // transición suave entre imágenes
        spaceBetween={spaceBetween}
        slidesPerView={sildesPerView}
        navigation={navigation}
        pagination={pagination ? { clickable: true, type: "bullets" } : false}
        autoplay={
          autoPlay ? { delay: 3000, disableOnInteraction: false } : false
        }
        speed={3000} //la animación tarde 1 segundo
        watchSlidesProgress={true} // agregado
        breakpoints={{
          0: { slidesPerView: sildesPerViewTwo == 2 ? 2 : sildesPerView }, // < 480px
          480: { slidesPerView: sildesPerViewTwo == 2 ? 3 : sildesPerView }, // 480px – 766px
          767: { slidesPerView: sildesPerViewTwo == 2 ? 4 : sildesPerView }, // 767px – 990px
          991: { slidesPerView: sildesPerViewTwo == 2 ? 5 : sildesPerView }, // 991px – 1199px
          1024: { slidesPerView: sildesPerViewTwo == 2 ? 5 : sildesPerView }, // >= 1200px
          1200: { slidesPerView: sildesPerView },
        }}
        className="rounded-2xl">
        {React.Children.map(children, (child, index) => (
          <SwiperSlide
            key={index}
            className={classNamex != "" ? classNamex : "flex justify-center"}>
            {/*child*/}
            {({ isActive }: { isActive: boolean }) => {
              const shouldLoad = isActive && index === activeIndex;
              return shouldLoad ? child : <div></div>;
            }}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};
